import { GallectionType } from '../../types/gallection';
import { stashFolderSchema, collectionFolderSchema, galleryFolderSchema, stashListSchema, collectionListSchema, galleryListSchema, gallectionListSchema } from './schemas/folder';
import { normalize } from '.';
import { deviationListSchema, deviationSchema } from './schemas/deviation';
import { userListSchema, userSchema } from './schemas/user';
export function getGallectionSchema(gallection) {
    switch(gallection.type){
        case GallectionType.STASH:
            return stashFolderSchema;
        case GallectionType.PRIVATE_COLLECTION:
        case GallectionType.COLLECTION:
            return collectionFolderSchema;
        case GallectionType.GALLERY:
        default:
            return galleryFolderSchema;
    }
}
export function getGallectionListSchema(gallections) {
    var _gallections_;
    switch((_gallections_ = gallections[0]) === null || _gallections_ === void 0 ? void 0 : _gallections_.type){
        case GallectionType.STASH:
            return stashListSchema;
        case GallectionType.PRIVATE_COLLECTION:
        case GallectionType.COLLECTION:
            return collectionListSchema;
        case GallectionType.GALLERY:
        default:
            return galleryListSchema;
    }
}
export function normalizeGallection(gallection) {
    const schema = getGallectionSchema(gallection);
    const { entities } = normalize(gallection, schema);
    return entities;
}
export function normalizeGallections(gallections) {
    const schema = getGallectionListSchema(gallections);
    const { entities, result } = normalize(gallections, schema);
    return {
        entities,
        result
    };
}
// normalize mixed PapiGallection array
export function normalizeGallectionsMixed(gallections) {
    const { entities, result } = normalize(gallections, gallectionListSchema);
    return {
        entities,
        result
    };
}
export function normalizeDeviation(deviation) {
    const { entities } = normalize(deviation, deviationSchema);
    return entities;
}
export function normalizeDeviations(deviations) {
    const { entities, result } = normalize(deviations, deviationListSchema);
    return {
        entities,
        result
    };
}
export function normalizeUser(user) {
    const { entities } = normalize(user, userSchema);
    return entities;
}
export function normalizeUsers(users) {
    const { entities, result } = normalize(users, userListSchema);
    return {
        entities,
        result
    };
}

//# sourceMappingURL=helpers.js.map